import * as React from 'react';

import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Granularity } from 'bloggers-backend/lib/bloggers/domain';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';

const granularities: Granularity[] = ['month', 'week', 'day'];

interface ReportControlsProps {
  granularity: Granularity;
  onGranularityChange: (granularity: Granularity) => void;
  dateRange: DateRange<Dayjs>;
  onDateRangeChange: (dateRange: DateRange<Dayjs>) => void;
  children?: React.ReactNode;
}

export function ReportControls(
  { granularity, onGranularityChange, dateRange, onDateRangeChange, children }: ReportControlsProps) {
  return (
    <Box sx={{ display: 'flex', gap: 2, marginBottom: 2 }}>
      <FormControl sx={{ minWidth: 140 }}>
        <InputLabel id="granularity-label">granularity</InputLabel>
        <Select
          id="granularity"
          labelId="granularity-label"
          label="granularity"
          value={granularity}
          onChange={(event) => {
            const selected = granularities.find((option) => option === event.target.value);
            if (selected) {
              onGranularityChange(selected);
            }
          }}
        >
          {granularities.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)}
        </Select>
      </FormControl>
      {children}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateRangePicker
          value={dateRange}
          onChange={onDateRangeChange}
          format="DD/MM/YYYY"
          localeText={{ start: 'start date', end: 'end date' }}
        />
      </LocalizationProvider>
    </Box>
  );
}
